module.exports = __webpack_public_path__ + "img/back.500e51db.png";